module.exports = __webpack_public_path__ + "img/ehrlich.2d2c7735.jpg";